import { MemberDatasource } from './../../../global/datasources/member_datasource';
import { IDelegateController, IDelegateConstant, IDelegateResponder } from 'ui-ng-delegate';

interface ICaptchaWidgetScope extends ng.IScope {
  responseKey: string;
  $ctrl: CaptchaWidgetController;
}

export class CaptchaWidgetController {
  responseKey: string = '';

  constructor(ngMemberDatasource: MemberDatasource, private $scope: ICaptchaWidgetScope) {
    (window as any).__global__grecaptcha_onloadCallback = () => {
      (window as any).grecaptcha.render('captcha', {
        sitekey: ngMemberDatasource.read().core_config.google_captcha_site_key,
        callback: this.verifyCallback.bind(this),
        'expired-callback': this.expiredCallback.bind(this)
      });
    };
  }

  expiredCallback(): void {
    this.$scope.responseKey = '';
    (window as any).grecaptcha.reset();
  }

  verifyCallback(response: string): void {
    this.$scope.responseKey = response;
  }
}

class CaptchaWidgetDelegate {
  constructor(DelegateController: IDelegateController, captchaWidgetDelegateConfiguration: IDelegateConstant) {
    DelegateController(this, captchaWidgetDelegateConfiguration);
  }
}

angular
  .module('capability-ng-user-app')
  .service('captchaWidgetDelegate', CaptchaWidgetDelegate)
  .constant('captchaWidgetDelegateConfiguration', {
    uniqueComponent: 'captcha-widget',
    vocabulary: {
      reset: function(scope: ICaptchaWidgetScope) {
        scope.$ctrl.expiredCallback();
      }
    }
  })
  .directive('captchaWidget', function(
    DelegateResponder: IDelegateResponder,
    captchaWidgetDelegateConfiguration: IDelegateConstant
  ) {
    return {
      templateUrl: 'lib/user_app/components/captcha_widget/captcha_widget.html',
      controller: CaptchaWidgetController,
      controllerAs: '$ctrl',
      scope: {
        responseKey: '='
      },
      link: DelegateResponder(captchaWidgetDelegateConfiguration, function(scope, elements, attrs) {})
    };
  });



// WEBPACK FOOTER //
// ./app/lib/user_app/components/captcha_widget/captcha_widget.ts